import { useContext } from 'react';
import ProductContext, { DataContextType } from '../DataContext';

/* hook for RatingData */
export const useRating = (): DataContextType['ratingData'] => {
  const { ratingData } = useContext(ProductContext);
  return ratingData;
};

export default useRating;
